module.exports = __webpack_public_path__ + "img/login_03.07ef092c.jpg";